import { render } from "./BlockDefault.vue?vue&type=template&id=0ddbacf9&scoped=true"
import script from "./BlockDefault.vue?vue&type=script&lang=js"
export * from "./BlockDefault.vue?vue&type=script&lang=js"

import "./BlockDefault.vue?vue&type=style&index=0&id=0ddbacf9&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddbacf9"]])

export default __exports__